import React from 'react';
import { SameDepartmentRequestsProps } from '../types/leaveRequestType';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import UserShortCut from 'components/common/UserShortCut';

const SameDepartmentRequests: React.FC<SameDepartmentRequestsProps> = ({
  requests,
}) => {
  const { t } = useTranslation();
  if (requests?.length < 1) {
    return <></>;
  }
  return (
    <>
      <div className="minthr-flex minthr-flex-items-center minthr-mt-6 minthr-mb-4">
        <h4>{t('Demande.Info.sameDepartement')}</h4>
        <span className="minthr-badge minthr-badge-primary minthr-badge-s minthr-ml-2">
          {requests?.length}
        </span>
      </div>
      <div className="slick-sameDepartement">
        {requests?.map((item) => (
          <div
            key={item.id}
            className="minthr-border minthr-border-rounded minthr-p-3 minthr-pl-6 minthr-mb-4 minthr-mx-2"
          >
            <div className="minthr-border-b minthr-flex minthr-flex-items-center minthr-flex-space-between minthr-pb-2">
              <div>
                <h5>{t(item.type)}</h5>
                <span className="minthr-icon-text">
                  <img
                    className="minthr-icon-xs"
                    src="/icons/calendar.svg"
                    alt="calendar icon"
                    width={16}
                    height={16}
                  />
                  {moment(item.startDate).format('DD MMM yyyy')} -{' '}
                  {moment(item.endDate).format('DD MMM yyyy')}
                </span>
              </div>
              <div className="minthr-ml-auto h4 minthr-color-primary minthr-text-align-right">
                {item.nbrDay} {t('Constant.day')}
              </div>
            </div>
            <div className="minthr-flex minthr-flex-items-center minthr-pt-2">
              <UserShortCut
                userId={item.id}
                userPath={item.image}
                className="minthr-avatar minthr-avatar-m"
                alt={item.fullName}
              />
              <div className="minthr-ml-2 minthr-overflow-hidden">
                <div className="h5 text-s minthr-text-truncate minthr-mb-1">
                  {item.fullName}
                </div>
                <p className="text-s">{item.fonctionName}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default SameDepartmentRequests;
